import { PLATFORM_ENUM } from 'services/api/constants'
import { checkInType } from './index'
import { TFunction } from 'i18next'
import { GridColDef } from '@mui/x-data-grid-pro'

export enum FIELDS_TYPE {
    GENDER = 'gender',
    EMPLOYMENT_STATUS = 'occupation',
    NAME = 'name',
    IG_USERNAME = 'igUsername',
    FB_USERNAME = 'fbUsername',
    TIKTOK_USERNAME = 'tiktokUsername',
    TWITTER_USERNAME = 'twitterUsername',
    MCQ = 'question_block',
    OPEN_ENDED_Q = 'text_submission_block',
    URL = 'url_submission_block',
    IG_FOLLOWERS = 'igFollowers',
    FB_FRIENDS = 'fbFriends',
    TIKTOK_FOLLOWERS = 'tiktokFollowers',
    TWITTER_FOLLOWERS = 'twitterFollowers',
    AGE = 'age',
    NUMBER = 'number',
    MEET_REQUIREMENT = 'meetRequirement',
    CREATED_AT = 'created_at',
    APPROVED_AT = 'approved_at',
    ACCEPTED_AT = 'accepted_at',
    DECLINED_AT = 'declined_at',
    APPROVAL_EXPIRED_AT = 'approval_expired_at',
    FIRST_CONTENT_SUBMITTED_AT = 'first_content_submitted_at',
    LOCATION = 'location',
    STATUS = 'status',
    HIGHLIGHT = 'highlight',
    PARTIPOSTER_TAGS = 'partiposterTags',
    VOTE_TYPE = 'voteType',
    RESUBMITTED = 'resubmitted',
    TEAM_TYPE = 'teamType',
    PROFILE = 'profile',
    SOCIAL_MEDIA_INFO = 'socialMediaInfo',
    FAVORITE = 'favorite',
    SOCIAL_MEDIA_FOLLOWER_NUMBER_TIER = 'social_media_follower_number_tiers',
    PROFILE_TYPE = 'profile_tier',
    AMBASSADOR_BRAND = 'brand_name',
    AVERAGE_VIEWS = 'view',
    AVERAGE_IMPRESSIONS = 'impression',
    AVERAGE_ENGAGEMENT_RATE = 'engagement_rate',
    AVERAGE_CONTENT_ENGAGEMENT_RATE = 'content_engagement_rate',
    AVERAGE_ENGAGEMENT = 'engagement_sum',
    AVERAGE_ENGAGEMENT_LIKES = 'like',
    AVERAGE_ENGAGEMENT_COMMENTS = 'comment',
    AVERAGE_ENGAGEMENT_SAVES = 'save',
    AVERAGE_ENGAGEMENT_SHARES = 'share',
    AVERAGE_REACH = 'reach',
    AVERAGE_TAGS = 'tag',
    AVERAGE_CTA_CLICKS = 'cta_click',
    NUMBER_OF_LINK_CLICKS = 'link_click',
    NUMBER_OF_STICKER_TAPS = 'sticker_tap',
}

export enum SORT_DIRECTION {
    ASC = 'asc',
    DESC = 'desc',
}

// keys are the fields type , values are their relative field name in CM
const sortableFieldsArray: string[] = [
    FIELDS_TYPE.GENDER,
    FIELDS_TYPE.EMPLOYMENT_STATUS,
    FIELDS_TYPE.NAME,
    FIELDS_TYPE.IG_USERNAME,
    FIELDS_TYPE.FB_USERNAME,
    FIELDS_TYPE.TIKTOK_USERNAME,
    FIELDS_TYPE.TWITTER_USERNAME,
    FIELDS_TYPE.OPEN_ENDED_Q,
    FIELDS_TYPE.URL,
    FIELDS_TYPE.IG_FOLLOWERS,
    FIELDS_TYPE.FB_FRIENDS,
    FIELDS_TYPE.TIKTOK_FOLLOWERS,
    FIELDS_TYPE.TWITTER_FOLLOWERS,
    FIELDS_TYPE.AGE,
    FIELDS_TYPE.NUMBER,
    FIELDS_TYPE.MEET_REQUIREMENT,
    FIELDS_TYPE.CREATED_AT,
    FIELDS_TYPE.APPROVED_AT,
    FIELDS_TYPE.ACCEPTED_AT,
    FIELDS_TYPE.DECLINED_AT,
    FIELDS_TYPE.APPROVAL_EXPIRED_AT,
    FIELDS_TYPE.FIRST_CONTENT_SUBMITTED_AT,
    FIELDS_TYPE.HIGHLIGHT,
    FIELDS_TYPE.PROFILE,
    FIELDS_TYPE.SOCIAL_MEDIA_INFO,
    FIELDS_TYPE.AMBASSADOR_BRAND,
    FIELDS_TYPE.AVERAGE_VIEWS,
    FIELDS_TYPE.AVERAGE_IMPRESSIONS,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_RATE,
    FIELDS_TYPE.AVERAGE_CONTENT_ENGAGEMENT_RATE,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT,
    FIELDS_TYPE.AVERAGE_REACH,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_LIKES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_SHARES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_SAVES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_COMMENTS,
    FIELDS_TYPE.AVERAGE_CTA_CLICKS,
    FIELDS_TYPE.NUMBER_OF_LINK_CLICKS,
    FIELDS_TYPE.NUMBER_OF_STICKER_TAPS,
    FIELDS_TYPE.PROFILE_TYPE,
]

const typeAToZFields: string[] = [
    FIELDS_TYPE.GENDER,
    FIELDS_TYPE.EMPLOYMENT_STATUS,
    FIELDS_TYPE.NAME,
    FIELDS_TYPE.IG_USERNAME,
    FIELDS_TYPE.FB_USERNAME,
    FIELDS_TYPE.TIKTOK_USERNAME,
    FIELDS_TYPE.TWITTER_USERNAME,
    FIELDS_TYPE.MCQ,
    FIELDS_TYPE.URL,
    FIELDS_TYPE.OPEN_ENDED_Q,
    FIELDS_TYPE.STATUS,
    FIELDS_TYPE.PROFILE_TYPE,
]
const typeHighestToLowest: string[] = [
    FIELDS_TYPE.IG_FOLLOWERS,
    FIELDS_TYPE.FB_FRIENDS,
    FIELDS_TYPE.TIKTOK_FOLLOWERS,
    FIELDS_TYPE.TWITTER_FOLLOWERS,
    FIELDS_TYPE.AGE,
    FIELDS_TYPE.NUMBER,
    FIELDS_TYPE.AMBASSADOR_BRAND,
    FIELDS_TYPE.AVERAGE_VIEWS,
    FIELDS_TYPE.AVERAGE_IMPRESSIONS,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_RATE,
    FIELDS_TYPE.AVERAGE_CONTENT_ENGAGEMENT_RATE,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT,
    FIELDS_TYPE.AVERAGE_REACH,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_LIKES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_SHARES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_SAVES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_COMMENTS,
    FIELDS_TYPE.AVERAGE_CTA_CLICKS,
    FIELDS_TYPE.NUMBER_OF_LINK_CLICKS,
    FIELDS_TYPE.NUMBER_OF_STICKER_TAPS,
]

const typeLatestToOldest: string[] = [
    FIELDS_TYPE.ACCEPTED_AT,
    FIELDS_TYPE.CREATED_AT,
    FIELDS_TYPE.APPROVED_AT,
    FIELDS_TYPE.DECLINED_AT,
    FIELDS_TYPE.APPROVAL_EXPIRED_AT,
    FIELDS_TYPE.FIRST_CONTENT_SUBMITTED_AT,
]

const typeOppositeSortFields: string[] = [
    FIELDS_TYPE.IG_FOLLOWERS,
    FIELDS_TYPE.FB_FRIENDS,
    FIELDS_TYPE.TIKTOK_FOLLOWERS,
    FIELDS_TYPE.TWITTER_FOLLOWERS,
    FIELDS_TYPE.AGE,
    FIELDS_TYPE.NUMBER,
    FIELDS_TYPE.ACCEPTED_AT,
    FIELDS_TYPE.CREATED_AT,
    FIELDS_TYPE.APPROVED_AT,
    FIELDS_TYPE.DECLINED_AT,
    FIELDS_TYPE.APPROVAL_EXPIRED_AT,
    FIELDS_TYPE.FIRST_CONTENT_SUBMITTED_AT,
    FIELDS_TYPE.HIGHLIGHT,
    FIELDS_TYPE.AVERAGE_VIEWS,
    FIELDS_TYPE.AVERAGE_IMPRESSIONS,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_RATE,
    FIELDS_TYPE.AVERAGE_CONTENT_ENGAGEMENT_RATE,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT,
    FIELDS_TYPE.AVERAGE_REACH,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_LIKES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_SHARES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_SAVES,
    FIELDS_TYPE.AVERAGE_ENGAGEMENT_COMMENTS,
    FIELDS_TYPE.AVERAGE_CTA_CLICKS,
    FIELDS_TYPE.NUMBER_OF_LINK_CLICKS,
    FIELDS_TYPE.NUMBER_OF_STICKER_TAPS,
]

const socialPlatformFields: string[] = [
    FIELDS_TYPE.IG_FOLLOWERS,
    FIELDS_TYPE.IG_USERNAME,
    FIELDS_TYPE.FB_FRIENDS,
    FIELDS_TYPE.FB_USERNAME,
    FIELDS_TYPE.TIKTOK_FOLLOWERS,
    FIELDS_TYPE.TIKTOK_USERNAME,
    FIELDS_TYPE.TWITTER_FOLLOWERS,
    FIELDS_TYPE.TWITTER_USERNAME,
]

const typeYesToNo: string[] = [FIELDS_TYPE.MEET_REQUIREMENT, FIELDS_TYPE.FAVORITE]

const blockPlatformFields: string[] = [FIELDS_TYPE.URL, FIELDS_TYPE.MCQ, FIELDS_TYPE.NUMBER, FIELDS_TYPE.OPEN_ENDED_Q]

export const isSortable = (field: string) => checkInType(field, sortableFieldsArray)
export const isAToZField = (field: string) => checkInType(field, typeAToZFields)
export const isHighestToLowestField = (field: string) => checkInType(field, typeHighestToLowest)
export const isLatestToOldestField = (field: string) => checkInType(field, typeLatestToOldest)
export const isOppositeSortField = (field: string) => checkInType(field, typeOppositeSortFields)
export const isYesToNoField = (field: string) => checkInType(field, typeYesToNo)

export const getSortQueryText = (field: string, sortDirection: 'asc' | 'desc') => {
    let ordering = field
    const isBlockField = checkInType(field, blockPlatformFields)
    if (socialPlatformFields.includes(field)) {
        const platformNumber = field.includes('fb')
            ? PLATFORM_ENUM.FB
            : field.includes('ig')
              ? PLATFORM_ENUM.IG
              : field.includes('tiktok')
                ? PLATFORM_ENUM.TIKTOK
                : PLATFORM_ENUM.TWITTER
        const prefix = field.includes('Username') ? 'username' : 'follower_count'
        ordering = `${prefix}_${platformNumber}`
    }
    if (isBlockField) {
        const uuid = field.split('+')[1]
        ordering = `block_${uuid}`
    }
    if (field === FIELDS_TYPE.MEET_REQUIREMENT) {
        return sortDirection === 'asc'
            ? 'recommended_priority_order,unmet_requirement'
            : 'unmet_requirement,recommended_priority_order'
    }
    if (field === FIELDS_TYPE.HIGHLIGHT) {
        ordering = 'highlighted'
    }
    return sortDirection === 'asc' ? ordering : `-${ordering}`
}

export const getSubFieldValues = (t: TFunction): Record<string, GridColDef> => {
    return {
        [FIELDS_TYPE.NAME]: {
            field: FIELDS_TYPE.NAME,
            headerName: t('submission.table.nameLabel'),
        },
        [FIELDS_TYPE.GENDER]: {
            field: FIELDS_TYPE.GENDER,
            headerName: t('submission.table.genderLabel'),
        },
        [FIELDS_TYPE.AGE]: {
            field: FIELDS_TYPE.AGE,
            headerName: t('submission.table.ageLabel'),
        },
        [FIELDS_TYPE.MEET_REQUIREMENT]: {
            field: FIELDS_TYPE.MEET_REQUIREMENT,
            headerName: t('submission.table.meetRequirementsLabel'),
        },
        [FIELDS_TYPE.IG_FOLLOWERS]: {
            field: FIELDS_TYPE.IG_FOLLOWERS,
            headerName: t('submission.table.instagramFollowersLabel'),
        },
        [FIELDS_TYPE.IG_USERNAME]: {
            field: FIELDS_TYPE.IG_USERNAME,
            headerName: t('submission.table.instagramUsernameLabel'),
        },
        [FIELDS_TYPE.FB_FRIENDS]: {
            field: FIELDS_TYPE.FB_FRIENDS,
            headerName: t('submission.table.facebookFriendsLabel'),
        },
        [FIELDS_TYPE.FB_USERNAME]: {
            field: FIELDS_TYPE.FB_USERNAME,
            headerName: t('submission.table.facebookUsernameLabel'),
        },
        [FIELDS_TYPE.TIKTOK_FOLLOWERS]: {
            field: FIELDS_TYPE.TIKTOK_FOLLOWERS,
            headerName: t('submission.table.tikTokFollowersLabel'),
        },
        [FIELDS_TYPE.TIKTOK_USERNAME]: {
            field: FIELDS_TYPE.TIKTOK_USERNAME,
            headerName: t('submission.table.tikTokUsernameLabel'),
        },
        [FIELDS_TYPE.TWITTER_FOLLOWERS]: {
            field: FIELDS_TYPE.TWITTER_FOLLOWERS,
            headerName: t('submission.table.twitterFollowersLabel'),
        },
        [FIELDS_TYPE.TWITTER_USERNAME]: {
            field: FIELDS_TYPE.TWITTER_USERNAME,
            headerName: t('submission.table.twitterUsernameLabel'),
        },
    }
}
